/**
 * Created by intellicar-rinas on 12/9/17.
 */
import React,{ Component,forwardRef } from 'react';
import {connect} from 'react-redux';
import io from 'socket.io-client';
import actions from '../../../store/actions';
import _ from 'lodash';
import MqttVehicleMap from './MqttVehicleMap';
import moment from "moment";


let gotAllBuckets = false;
let gotAllUserBuckets = false;
let bucketCount = 0;
let userBucketCount = 0;

window.mqttVehicleMap = new MqttVehicleMap();
let mqttVehicleMap = window.mqttVehicleMap;


class MQTTNew extends Component{

    constructor(){
        super();
        // this.isAuthed = false;
        this.connect  = this.connect.bind(this);
        this.onAuthSuccess  = this.onAuthSuccess.bind(this);
        this.onAuthFailure  = this.onAuthFailure.bind(this);
        this.subscribeSuccess  = this.subscribeSuccess.bind(this);
        this.unSubscribeSuccess  = this.unSubscribeSuccess.bind(this);
        this.onReceiveMsg  = this.onReceiveMsg.bind(this);
        this.getNextUserBucket  = this.getNextUserBucket.bind(this);
        this.subscribeGPS  = this.subscribeGPS.bind(this);
        this.onDisconnect  = this.onDisconnect.bind(this);
        this.getNextBucket  = this.getNextBucket.bind(this);
        this.unSubscribeSuccess  = this.unSubscribeSuccess.bind(this);
        this.sendToken  = this.sendToken.bind(this);
        this.callListeners  = this.callListeners.bind(this);
        this.reconnect_attempt  = this.reconnect_attempt.bind(this);
        this.reconnecting  = this.reconnecting.bind(this);
        this.reconnect  = this.reconnect.bind(this);
        this.reconnect_error  = this.reconnect_error.bind(this);
        this.reconnect_failed  = this.reconnect_failed.bind(this);
        this.onConnect  = this.onConnect.bind(this);
        this.clearAuthTimeout  = this.clearAuthTimeout.bind(this);
        this.handleAuthTimeout  = this.handleAuthTimeout.bind(this);

        // Timeout to track if no message received after sending auth token
        this.authTimeout = null;

        mqttVehicleMap.updateStoreVM =vehicleMap=> {
            this.props.dispatch({
                type:actions.VEHICLE_MAP_UPDATED,
                data:vehicleMap
            });
        }

        window.mqttListeners = [];
        window.listenToMQTT = (type, method, key) => {
            if(!(key in window.mqttListeners)) {
                if(!(type in window.mqttListeners)){
                    window.mqttListeners[type] = {}
                }
                window.mqttListeners[type][key] = method;
            }
        };

        window.simulateRTAlerts =(max = 30, interTime=1000) => {
            console.warn(' ========= SIM =========');

            const alarmTypes = [
                'Harsh Acceleration',
                'Harsh Braking',
                'Harsh Left Turn',
                'Harsh Right Turn',
                'Over Speeding',
                'Long Idling',
            ]

            let vp = 30874;
            let counter = 0;
            let inter = setInterval(()=> {
                counter++;
                let index = Math.floor(alarmTypes.length * Math.random());
                let al = alarmTypes[index];
                this.onReceiveMsg({
                    al,
                    vp,
                    lt:0,
                    ln:0,
                    uts: Date.now()
                }, 'ALARMRT');

                if(counter > max) {
                    clearInterval(inter);
                }
            }, interTime);
        };
    }

    callListeners(source, msg){
        for(let idx in window.mqttListeners[source]) {
            if(window.mqttListeners[source][idx]) {
                window.mqttListeners[source][idx](msg);
            }
        }
    }

    onConnect() {
        // console.log("calling on connect",this.socket)
        if(this.socket){
            this.sendToken();
            this.socket.on('authsuccess', this.onAuthSuccess);
            this.socket.on('authfailure', this.onAuthFailure);
            this.socket.on('subscribesuccess', this.subscribeSuccess);
            this.socket.on('unsubscribesuccess', this.unSubscribeSuccess);
            this.socket.on('gpsrt', m=>this.onReceiveMsg(m, 'GPS'));
            this.socket.on('usergpsrt', m=>this.onReceiveMsg(m, 'GPS', 'user'));
            this.socket.on('userphoneinfo', m=>this.onReceiveMsg(m, 'PHONEINFO'));
            this.socket.on('canrt', m=>this.onReceiveMsg(m, 'CAN'));
            this.socket.on('canrt2', m=>this.onReceiveMsg(m, 'CAN2'));
            this.socket.on('klert', m=>this.onReceiveMsg(m, 'KLE'));
            this.socket.on('dtcrt', m=>this.onReceiveMsg(m, 'DTC'));
            this.socket.on('tpms', m=>this.onReceiveMsg(m, 'TPMS'));
            this.socket.on('alarmrt', m=>this.onReceiveMsg(m, 'ALARMRT'));

            this.socket.on('reconnect', this.reconnect);
            this.socket.on('reconnect_attempt', this.reconnect_attempt);
            this.socket.on('reconnecting', this.reconnecting);
            this.socket.on('reconnect_error', this.reconnect_error);
            this.socket.on('reconnect_failed', this.reconnect_failed);
            this.socket.on('forcerefresh', this.forceRefresh);
        }else{
            console.warn("Connecting to MQTT Failed");
            setTimeout(this.connect, 5000)
        }
    }

    componentDidMount(){
        this.connect();

        if(this.props.onload) {
            this.props.onload(this);
        }

        this.onSimulation =m=> {

            this.onReceiveMsg({...m,
                uts:Date.now(),
                ig:Math.floor(this.getRandom(0, 2)),
                en:Math.floor(this.getRandom(0, 2)),
                vs:Math.floor(this.getRandom(0, 2)),
                rpm:this.getRandom(0, 3000),
                hm:this.getRandom(0, 100),
                bv:this.getRandom(0, 24),
                cs:Math.floor(this.getRandom(0, 2)),
                fl:this.getRandom(0, 100),
                ect:Math.floor(this.getRandom(0, 2)),
                eop:Math.floor(this.getRandom(0, 2)),
                aci:Math.floor(this.getRandom(0, 2)),
                mm:parseInt(this.getRandom(0, 2)),
                es:Math.floor(this.getRandom(0, 2)),
                sp:this.getRandom(0, 100),
            }, 'CAN2');


            this.onReceiveMsg({...m,
                uts:Date.now(),
                lst: this.getRandom(0, 100),
                rst: this.getRandom(0, 100),
                bct: this.getRandom(0, 100),
                aes: this.getRandom(0, 3000),
                eh: this.getRandom(0, 10),
                ds: this.getRandom(0, 100),
                bci: Math.floor(this.getRandom(0, 2)),
                wh: this.getRandom(0, 10),
                wm: this.getRandom(0, 100),
                pd: this.getRandom(0, 100),
                wlm: this.getRandom(0, 100),
                wli: this.getRandom(0, 100),
                tdl: this.getRandom(0, 100),
                tdh: this.getRandom(0, 100),
                iig: Math.floor(this.getRandom(0, 2)),
                iov: this.getRandom(0, 100),
                ioe: Math.floor(this.getRandom(0, 2)),
                whm: this.getRandom(0, 100),
                whi:this.getRandom(0, 100),
                eol: Math.floor(this.getRandom(0, 2)),
                hct: Math.floor(this.getRandom(0, 2)),
                sm: '808472629',
                sl: '808472629',
                mm: '808472629',
                ml: '808472629',
                hfi: Math.floor(this.getRandom(0, 2)),
                ioa: Math.floor(this.getRandom(0, 2)),
                shm: Math.floor(this.getRandom(0, 2)),
                shsr: parseInt(this.getRandom(0, 3)),
                shsl: parseInt(this.getRandom(0, 3)),
                shsb: parseInt(this.getRandom(0, 3)),
            }, 'CAN');

            this.tempArr = {};
            this.onReceiveMsg({...m,
                tpms:(()=>{
                    let sensorCount = 40;
                    let arr = [];
                    for(let idx=0; idx < sensorCount; idx++) {
                        if(!(idx in this.tempArr)) {
                            this.tempArr[idx] = {
                                temp: 40,
                                pressure: 100,
                            }
                        }
                        this.tempArr[idx].temp = parseInt(this.getRandom(this.tempArr[idx].temp-4, 8), 10);
                        this.tempArr[idx].pressure = parseInt(this.getRandom(this.tempArr[idx].pressure-4, 8), 10);
                        arr.push({
                            sid: idx,
                            tp: this.tempArr[idx].pressure,
                            tt: this.tempArr[idx].temp
                        })
                    }
                    return arr;
                })()
            }, 'TPMS')
        };

        this.startSimulation = m => {
            if(this.simulationEngine) return;
            this.simulationEngine = setInterval(()=>this.onSimulation(m), 5000);
            this.onSimulation(m);
        };

        this.startMQTTSimulation =()=> {
            if(this.VPForSimulation) {
                this.startSimulation({vp:this.VPForSimulation});
            }
        };

        this.stopMQTTSimulation =()=> {
            if(this.simulationEngine) {
                clearInterval(this.simulationEngine);
                this.simulationEngine = null
            }
        };

        window.startMQTTSimulation =()=> this.startMQTTSimulation();
        window.stopMQTTSimulation =()=> this.stopMQTTSimulation();
        window.getMQTTSimulationStatus =()=> {return this.simulationEngine ? true : false; };
    }
    componentWillUnmount() {
        // Clear auth timeout if component unmounts
        // this.clearAuthTimeout();
        
        if (this.socket) {
            console.log("calling close socket")
          this.socket.close();
        }
      }

    getRandom(min, max) {
        return parseFloat(min + parseFloat((Math.random() * max).toFixed(1)));
    }


    forceRefresh(){
        window.location.reload();
    }


    reconnect_attempt (attempt) {
        console.log("Reconnect attempt", attempt);
    };

    reconnecting (attempt) {
        console.log("Reconnecting", attempt);
    };

    reconnect (attempt) {
        console.log("Reconnected to Realtime Channel", attempt);
        this.sendToken();
    };

    reconnect_error (err) {
        console.log("Unable to reach server");
    };

    reconnect_failed () {
        console.log("Reconnect failed");
    };

    onAuthSuccess(msg){
        // Clear the auth timeout as we received a message
        // this.clearAuthTimeout();
        // this.isAuthed = true;
        console.log("msg",msg)
        // if(msg.vehiclecount === 0) {
        //     this.socket.close()
        //     console.log("vehiclecount is 0 ,disconnect and conncecting again")
        //     this.connect()
        // }
        console.log('Realtime Channel authSuccess');
        this.subscribeGPS();
        this.subscribeUserGPS();
    }

    onAuthFailure(msg){
        // Clear the auth timeout as we received a message
        // this.clearAuthTimeout();
        // this.isAuthed = false;
        console.log('Realtime Channel authFailure');
        this.onDisconnect();
    }

    subscribeSuccess(msg){
        if(msg.datarequested.indexOf('usergps') !== -1) {
            // console.log("Subscribing to User GPS");
            this.getNextUserBucket();
        }else if(msg.datarequested.indexOf('gps') !== -1) {
            console.log("Subscribing to GPS");
            this.getNextBucket();
        }
    }

    unSubscribeSuccess(msg){
        if(msg.datarequested.indexOf('gps') !== -1) {
            console.log("Unsubscribing from GPS");
            gotAllBuckets = false;
            bucketCount = 0;
        }
    }

    onReceiveMsg=(msg, source, type=null)=> {
        if (!this.props.RTGPS) return;

        if(source === 'ALARMRT') {
            window.alarmRT(msg); 
        }

        if (source == 'GPS') {
            // console.log('onReceiveMsg gps', msg);
            this.callListeners(source, msg);
        }

        if(type === 'user') {
            userBucketCount++;
            this.getNextUserBucket(msg);
            for (let idx in msg[1]) {
                msg[1][idx].vp = 'user_'+msg[1][idx].ui;
            }
        }

        if(source === 'GPS' && type === null) {
            bucketCount++;
            this.getNextBucket(msg);
        }
        if(source === "CAN"){
            if(msg.ct === null && msg.maxct !== undefined){
                msg.ct = msg.maxct
            }
        }

        if(source === 'GPS' && type !== 'USER' && msg.totalvehcount != null && msg.stats != null && msg.gps != null) {
            // console.log("num gps packets", msg.gps.msglist.length)
            mqttVehicleMap.updateVM(msg, gotAllBuckets);
        } else {
            this.props.onReceiveMessage({type:source, data:msg});
            this.callListeners(source, msg);
        }

        if(type !== 'user' && source !== 'GPS') {
            this.VPForSimulation = msg.vp ? msg.vp : null;
        }
        if(msg && msg.charging_updatedat){
            window.charging_updatedat =  moment(msg.charging_updatedat).format("DD-MMM-YYYY HH:mm") || "N/A"
        }
    }


// groups: [{...}, {...}] 
// onroad: false <- stats
// installation_type: "OBD_LOCK" 

// vehicleno: "DL1NA1945"
// chassisno: "MA3FHEB1S00C55517"
// odofrom: "can_odometer"
// odocalibration: ""
// modelinfo: {oem: "Maruti", model: "Swift", vehicletype: "Car", fueltype: "D", fueltankcapacity: 42, …}
// deviceinfo:

    getNextBucket(msg) {
        if (gotAllBuckets)
            return true;

        if ((msg && msg.gps && msg.gps.bucketid === 0 && bucketCount > 1) ){
            gotAllBuckets = true;
            this.props.onReceiveMessage({type: "GOT_ALL_BUCKETS"});
            this.props.dispatch({
                type: actions.GOT_ALL_BUCKETS,
                data: true
            });
            return;
        }

        if (this.socket) {
            // console.log("calling getnextbucket");
            setTimeout(() => {
                this.socket.emit("getnextbucket");
            }, 10);
        }
        return false;

    }

    getNextUserBucket(msg){
        if(gotAllUserBuckets)
            return true;

        if(msg && msg[0] === 0 && userBucketCount > 1){
            gotAllUserBuckets = true;
            return;
        }

        if(this.socket){
            setTimeout(()=>{
                this.socket.emit("getnextuserbucket");
            },10);
        }
        return false;
    }

    sendToken(){
        // Clear any existing timeout
        // this.clearAuthTimeout();
        // this.isAuthed = false;
        // Send auth token
        this.socket.emit('authtoken', this.props.auth.token);
        
        // Set timeout: if no message received within 20 seconds, close and reconnect
        this.authTimeout = setTimeout(() => {
            // this.handleAuthTimeout();
        }, 20000); // 20 seconds
    }

    clearAuthTimeout(){
        if (this.authTimeout) {
            clearTimeout(this.authTimeout);
            this.authTimeout = null;
        }
    }

    handleAuthTimeout(){
        // console.log('No message received within 10 seconds after sending auth token. Closing and reconnecting...');
        // if (this.isAuthed) {
        //     console.log('Auth already successful. Skipping reconnect.');
        //     return;
        //   }
        
        // console.log('No authsuccess within 20 seconds. Closing and reconnecting...');
        this.clearAuthTimeout();
        
        // Close the socket connection
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
        
        // Reconnect after a short delay
        setTimeout(() => {
            this.connect();
        }, 1000);
    }

    subscribeGPS(sub = true){
        if (this.socket !== null) {
            let msg = {
                data: [{
                    vehicleid: ["all"],
                    datarequested: [
                        "gps"
                    ]
                }]
            };

            if(sub){
                this.socket.emit('subscribe', msg);
            }else{
                this.socket.emit('unsubscribe', msg);
            }
            
            if(window.isWhiteLabelAvailable('iocl')) {
                msg = {
                    data: [{
                        vehicleid: ["all"],
                        datarequested: [
                            "alarm"
                        ]
                    }]
                };
    
                if(sub){
                    this.socket.emit('subscribe', msg);
                }else{
                    this.socket.emit('unsubscribe', msg);
                }
            }
        }
    }

    subscribeUserGPS(sub = true){
        if (this.socket !== null) {
            const msg = {
                data: [{
                    vehicleid: ["all"],
                    datarequested: [
                        "usergps"
                    ]
                }]
            };

            if(sub){
                this.socket.emit('subscribe', msg);
            }else{
                this.socket.emit('unsubscribe', msg);
            }
        }
    }

    subscribeCAN(vehicleid, sub) {
        if (this.socket !== null) {
            const msg = {
                data: [{
                    vehicleid: [vehicleid],
                    datarequested: [
                        "can"
                    ]
                }]
            };

            if(sub){
                this.socket.emit('subscribe', msg);
            }else{
                this.socket.emit('unsubscribe', msg);
                this.stopMQTTSimulation();
            }
        }
    }

    subscribePhoneInfo(userid, sub) {
        if (this.socket !== null) {
            const msg = {
                data: [{
                    vehicleid: [userid],
                    datarequested: [
                        "userphoneinfo"
                    ]
                }]
            };

            if(sub){
                this.socket.emit('subscribe', msg);
            }else{
                this.socket.emit('unsubscribe', msg);
                clearInterval(this.userSim);
            }

        }
    }

    onDisconnect(msg){
        console.log('Disconnected from Realtime Channel');
        gotAllBuckets = false;
        bucketCount = 0;
    }

    connect(){
     
        this.socket = io(this.props.host, {transports:['websocket', 'polling']});
        this.socket.on('connect', this.onConnect);
        this.socket.on('disconnect', this.onDisconnect);
    }

    render(){ return null }
}

const MapPropsToState = (state) => {
    return {
        RTGPS:state.RTGPS,
        vehicleMap: state.vehicleMap
    }
};

const MQTT = forwardRef((props, ref) => {
    return <MQTTNew {...props} ref={ref} />;
  });

// export default connect(MapPropsToState, null, null, { withRef: true })(MQTT);
export default connect(MapPropsToState, null, null, { forwardRef: true })(MQTT);
